export type TrustPilotRawReview = {
    id: string;
    title: string;
    text: string;
    stars: number;
    consumer: {
        displayName: string;
    };
    createdAt: string;
    isVerified: boolean;
};

export type TrustPilotReview = {
    id: string;
    title: string;
    review: string;
    stars: number;
    name: string;
    createdAt: string;
    isVerified: boolean;
};

export type TrustPilotSummary = {
    displayName: string;
    /** Reviews at ANY rating. Use for "based on N reviews" wording. */
    totalReviews: number;
    /** Reviews rated 5 stars only. Use for any "N 5-star reviews" claim — `totalReviews` overstates it. */
    fiveStarReviews: number;
    score: number;
};

export type TrustPilotData = {
    reviews: TrustPilotReview[];
    summary: TrustPilotSummary;
};

export const MOCK_TRUST_PILOT_DATA = {
    reviews: [],
    summary: {
        displayName: "SpotPet",
        totalReviews: 1000,
        fiveStarReviews: 1000,
        score: 5
    }
};
